import {
  updateMultiFacet,
  dismissFloorFilter,
  updateSortFacet
} from "../../store/actionCreators";
import { isLargeMediumViewPort } from "../../ui/helpers/viewportHelper";
import applyFacets from "./apply";
import {
  analyticsAddPendingRefinementsToggled,
  analyticsAddPendingSortRefinement
} from "../../../../analytics/actions";
import { getFacets } from "../../../selectors";

export { default as clear } from "./clear";
export { default as clearAlwaysApply } from "./clearAlwaysApply";
export { default as clearAll } from "./clearAll";
export { default as selectAll } from "./selectAll";
export { default as applyFacets } from "./apply";
export { default as done } from "./done";

export function changeMultiFacet(toggledFacets, meta) {
  return (dispatch, getState) => {
    const deselections = Array.isArray(toggledFacets)
      ? toggledFacets.filter(t => t.isSelected === false)
      : [];
    const togglesForAnalytics =
      deselections.length > 0
        ? (() => {
            const state = getState();
            const facets = getFacets(state);

            return deselections
              .map(({ facetId, valueId }) => {
                const facet = facets.find(f => f.id === facetId);
                if (!facet) return null;
                const facetValue = facet.facetValues.find(
                  fv => fv.id === valueId
                );
                if (!facetValue) return null;

                return { facet, facetValue, isSelected: false };
              })
              .filter(Boolean);
          })()
        : [];
    dispatch(updateMultiFacet(toggledFacets, meta));
    if (togglesForAnalytics.length > 0) {
      dispatch(analyticsAddPendingRefinementsToggled(togglesForAnalytics));
    }
  };
}

export const dismissFloorDeselections = (dispatch, normalized) => {
  normalized
    .filter(n => n.facetId === "floor" && n.isSelected === false)
    .forEach(deselection => {
      dispatch(dismissFloorFilter(String(deselection.valueId)));
    });
};

export function changeMultiFacetAndApplyIfLargeMedium(toggledFacets) {
  return (dispatch, getState) => {
    const state = getState();
    const normalized = toggledFacets.map(
      ({ facet, facetValue, isSelected }) => ({
        facetId: facet.id,
        valueId: facetValue.id,
        isSelected
      })
    );

    const isMobile = !isLargeMediumViewPort(state);
    const meta = isMobile ? { skipDebounce: true } : {};

    dismissFloorDeselections(dispatch, normalized);

    dispatch(updateMultiFacet(normalized, meta));
    dispatch(analyticsAddPendingRefinementsToggled(toggledFacets));
  };
}

export const changeSort = ({ type, name }) => dispatch => {
  dispatch(updateSortFacet(type));
  dispatch(analyticsAddPendingSortRefinement({ type, name }));
  dispatch(applyFacets());
};
